// 获取当前的用户名称即手机号
import { makeAutoObservable, runInAction } from "mobx";
import { http } from "../utils";

class UserStore {
  userInfo = {}
  constructor(){
    makeAutoObservable(this)
  } 
  async getUserInfo(){
    // request data
    const res = await http.get('/api/user/profile')
    return runInAction(() => {
      this.userInfo = res.data
    })
  }
  
  async logout () {
    this.userInfo = {};
  }
}
export default UserStore;